export const SET_BUY_SELL_DATA = 'SET_BUY_SELL_DATA';